import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from '@angular/core';
import { environment } from 'mds-ui/environments/environment';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { UserVO } from '../models/userVO.model';
import { HttpErrorHandler, HandleError } from 'mds-ui/app/shared/service/http-error-handler.service';
import { DateTimeFormatPipe } from 'mds-ui/app/shared/pipes/date-time-format.pipe';

@Injectable()
export class UserService {
  private handleError: HandleError;
  public user: UserVO;
  public usersList: Array<UserVO>;
  dtformat = new DateTimeFormatPipe("en-US");
  url: Array<string> = new Array<string>();
  constructor(private _http: HttpClient, private httpErrorHandler: HttpErrorHandler) {
    this.handleError = httpErrorHandler.createHandleError('UserService');
  }
  private httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      "Cache-Control": "no-cache",
      Pragma: "no-cache"
    })
  };

  postUserInfo(user: UserVO): Observable<number> {
    return this._http.post<any>(
      environment.postUserURL, user, this.httpOptions)
      .pipe(
        catchError(this.handleError('postUserInfo', []))
      );
  }

  getUrl(url: string) {
    if (url.toUpperCase().includes("?")) {
      let b = [];
      b = url.split("?");
      return b[0];
    } else {
      return url;
    }
  }
}